module.exports = __webpack_public_path__ + "img/cvs-triggered.c5126e9b.svg";